import React from 'react';

const BreadCrumbArrow = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.557 2.67311C5.43361 2.69613 5.32045 2.77137 5.25001 2.87723C5.20047 2.95168 5.17989 3.01695 5.17636 3.11082C5.17199 3.22681 5.19204 3.30295 5.25091 3.39399C5.26614 3.41752 5.75502 3.90878 7.5576 5.71185L9.84498 7.99985L7.5576 10.2879C5.75502 12.0909 5.26614 12.5822 5.25091 12.6057C5.19204 12.6968 5.17199 12.7729 5.17636 12.8889C5.17896 12.9579 5.18893 13.0034 5.21347 13.0579C5.26381 13.1698 5.37402 13.27 5.49032 13.3095C5.59721 13.3459 5.73841 13.3389 5.83633 13.2924C5.92155 13.2519 5.7554 13.4152 8.27956 10.891C9.62615 9.54438 10.6303 8.537 10.6468 8.51612C10.8436 8.26702 10.882 7.92846 10.7457 7.64359C10.7179 7.58549 10.6842 7.53099 10.6468 7.48359C10.6303 7.46271 9.62615 6.45533 8.27956 5.10871C6.23381 3.06291 5.93645 2.76711 5.90463 2.74629C5.82035 2.69112 5.75534 2.67081 5.65514 2.66833C5.61039 2.66722 5.58087 2.66866 5.557 2.67311Z"
        fill="#A9AEB1"
      />
    </svg>
  );
};

export default BreadCrumbArrow;
